"use strict";

import React from "react";

const FlashMessage = (props) => {

    const {title='', message='', link='', linkTitle='',type='success'} = props;

    function getIcon(type) {
        switch (type) {
            case 'error':
                return 'warning';
            case 'default':
                return type;
        }
    }

    return (
        <div className={'notification notification--'+type}>
            <i className={getIcon(type)}></i>
            {!!title &&
                <h4 className={'notification__heading notification__heading--'+type}>
                    {title}
                </h4>}
            {!!message &&
                <p className={'notification__message notification__message--'+type}>{message}</p>
            }
            {!!link &&
                <a href={link} target="_blank">{linkTitle}</a>
            }
        </div>
    );

};

export default FlashMessage;